module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "group group--sidebar"
  }, [_c('h1', {
    staticClass: "h1 group__title mw600",
    style: ({
      'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    })
  }, [_vm._v("How would you like to "), _c('br', {
    staticClass: "hide-below-medium"
  }), _vm._v(" talk to your counselor?")]), _vm._v(" "), _c('ul', {
    staticClass: "appointment-type-list appointment-type-list--max-width"
  }, _vm._l((_vm.typesToShow), function(item, index) {
    return _c('li', {
      key: index,
      class: [
        "appointment-type-list__item appointment-type-list__item--small appointment-type-list__item--hover",
        _vm.selectedAppointmentType === item.type ? "appointment-type-list__item--active" : "" ],
      on: {
        "click": function($event) {
          return item.action(item.type)
        }
      }
    }, [_c('div', {
      staticClass: "appointment-type-list__content appointment-type-list__content--fixed"
    }, [_c('span', {
      class: [
        "appointment-type-list__icon",
        ("appointment-type-list__icon--" + (item.icon)) ]
    }), _vm._v(" "), _c('span', {
      staticClass: "appointment-type-list__description fw-medium"
    }, [_vm._v(_vm._s(item.description))])])])
  }), 0), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "p appointment__note"
  }, [_vm._v("For video chat, you’ll need a computer, tablet, or mobile phone with a camera."), _c('br', {
    staticClass: "hide-below-small"
  }), _vm._v(" To talk over the phone, we’ll give you a call.")])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64495418"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/provider/Appointment.vue
// module id = 506
// module chunks = 0